@if (isLimitedSale()) {
  @let priceData = pricing()?.sale;
  <div sales-info class="info">
    <div class="header">Limited Offer</div>
    <div>
      @switch (priceData?.type) {
        @case ("promotion") {
          @let promo = $promo(priceData!);
          <div class="promotion sale">
            <div class="title field">
              <span>{{ promo.promotionName }}</span>
            </div>
            <div class="starts field">
              <span class="label">Starts</span><span>{{ promo.effectiveDate | date }}</span>
            </div>
            <div class="ends field">
              <span class="label">Ends</span><span>{{ promo.expiryDate | date }}</span>
            </div>
          </div>
        }
        @case ("quote") {
          @let quote = $quote(priceData!);
          <div class="quote sale">
            <div class="title field">
              <span class="label">Quote #</span><span>{{ quote.quoteNumber }}</span>
            </div>
            <div class="line field">
              <span class="label">Line #</span><span>{{ quote.quoteLine }}</span>
            </div>
            <div class="starts field">
              <span class="label">Starts</span><span>{{ quote.effectiveDate | date }}</span>
            </div>
            <div class="ends field">
              <span class="label">Ends</span><span>{{ quote.expiryDate | date }}</span>
            </div>
          </div>
        }
      }
    </div>
    @switch (priceData?.type) {
      @case ("promotion") {
        @let promo = $promo(priceData!);
        <button mat-stroked-button [routerLink]="['/promotions', promo.promotionId]"><div class="label">View Promotion</div></button>
      }
      @case ("quote") {
        @let quote = $quote(priceData!);
        <button mat-stroked-button [routerLink]="['/quotes', quote.quoteId]"><div class="label">View Quote</div></button>
      }
    }
  </div>
}

@if (hasFees()) {
  <div fees-info class="info">
    <div class="header">Fees</div>
    <ideal-product-fees-view fees [pricing]="pricing()" [multiplyBy]="multiplyBy()" />
  </div>
}
